/* eslint-disable */
import Helpers from '@helpers';

$(document).ready(function () {
    $("#mobile\\:btn-confirm").click(function () {
        $("#mobile-modal").fadeIn();
        $('.modal-overlay').show();
        $('#site-container').addClass('blur');
        $('body').css('overflow', 'hidden');
        Helpers.LoadingHelper.showLoading();
        getMobile().then(function (response) {
            var mobileNumber = response.mobile;
            $("#mobile-modal\\:number").text(Helpers.Utils.ConvertToPersianDigit(mobileNumber));
            return mobileNumber;
        }).then(function (mobileNumber) {
            sendConfirmationSMS().then(function (sendSmsResponse) {
                if (sendSmsResponse.success === true) {
                    $("#mobile-modal\\:sending-code").hide();
                    $("#mobile-modal\\:code-sent").show();
                } else if (sendSmsResponse.success === false) {
                    $("#mobile-modal\\:sending-code").hide();
                    $("#mobile-modal\\:sending-error").show();
                }

                Helpers.LoadingHelper.hideLoading();
            });
        });

        return false;
    });

    $("#mobile-modal\\:confirm-button").click(function () {
        Helpers.LoadingHelper.showLoading();
        validateMobile().then(function (response) {
            if (response.success === true) {
                $("#confirmMobileMessage").hide();
                topMessageBoxShow("شماره موبایل شما با موفقیت تائید شد.", 5, "alert alert-success");
                Helpers.ModalHelper.hideModal();
                $("#mobile-modal").fadeOut();
                $('.modal-overlay').hide();
                $('.modal').fadeOut();
                $('#site-container').removeClass('blur');
                $('body').css('overflow', 'auto');
                //resetGalleryModal();
            } else {
                $("#mobile-modal\\:error").show();
            }

            Helpers.LoadingHelper.hideLoading();
        });

        return false;
    });

    $("#mobile-modal\\:code").keyup(function (e) {
        if (e.keyCode === 13) {
            $("#mobile-modal\\:confirm-button").trigger('click');
        }
    });

    $('.close-windows').click(e => {

        clearMobileModal();

        $("#mobile-modal").fadeOut();
        // hide overlay
        $('.modal-overlay').hide();

        // hide modal
        $('.modal').fadeOut();

        // remove blur
        $('#site-container').removeClass('blur');

        // reset body
        $('body').css('overflow', 'auto');

        
    })

    $('.modal-overlay').click(e => {

        clearMobileModal();

        $("#mobile-modal").fadeOut();
        // hide overlay
        $('.modal-overlay').hide();

        // hide modal
        $('.modal').fadeOut();

        // remove blur
        $('#site-container').removeClass('blur');

        // reset body
        $('body').css('overflow', 'auto');

        //resetGalleryModal();
        var elementExists = document.getElementById("mobile-modal");
        if (elementExists) {
            resetMobileModal();
        }
    })

    function clearMobileModal() {
        //Hide all errors
        $("#mobile-modal\\:sending-code").hide();
        $("#mobile-modal\\:code-sent").hide();
        $("#mobile-modal\\:sending-error").hide();
        $("#mobile-modal\\:error").hide();
        $("#mobile-modal\\:code").val('');
    }

    $('#btnInsuranceAccept,#insurance-modal>.close-windows').click(function () {
        $("#insurance-modal").hide();
        $('.modal-overlay').hide();
        $('#site-container').removeClass('blur');
        $('body').css('overflow', 'auto');
    });
});

// REST CALLS
function getMobile() {
    var request = {
        url: "/wservice/users.ashx?rv=" + Date.now(),
        method: "GET",
        "data": {
            action: "getMobile"
        }
    };

    return $.ajax(request);
}

function sendConfirmationSMS() {
    var request = {
        url: "/wservice/users.ashx?rv=" + Date.now(),
        method: "GET",
        "data": {
            action: "sendConfirmationSms"
        }
    };

    return $.ajax(request);
}

function validateMobile() {
    var request = {
        url: "/wservice/users.ashx?rv=" + Date.now(),
        method: "GET",
        "data": {
            action: "validateMobile",
            code: $("#mobile-modal\\:code").val()
        }
    };

    return $.ajax(request);
}